import React, { useEffect } from 'react'
import { Button, Card, CardBody, CardTitle, Col, Form, Input, Label, Row, FormFeedback } from "reactstrap";
import * as yup from "yup";
import { useFormik } from "formik";
import { updateAdminSettings } from 'helpers/API Calls/System & Settings/Admin Settings';

function Deposits({data}: any) {

  const formik = useFormik({
    initialValues: {
      enableBookingDeposit: false,
      bookingDepositAmount: ''
    },    
    validationSchema: yup.object().shape({
      enableBookingDeposit: yup.boolean(),
      bookingDepositAmount: yup.string().when(['enableBookingDeposit'], {
        is: true,
        then: () => yup.string()
          .required('Deposit amount is required')
          .matches(/^\d+(\.\d{1,2})?$/, 'Must be a valid amount')
          .test('range', 'Deposit amount must be greater than or equal to 0', 
            (value) => !value || parseFloat(value) >= 0)
      })
    }),
    onSubmit: async (values: any, { setSubmitting }) => {
      setSubmitting(true);
      const reqData = [
      {
        key: "DEPOSIT",
        value: values.enableBookingDeposit ? "ENABLED" : 'DISABLED',
        id: data.DEPOSIT.id,
      },
      {
        key: "DEPOSIT_AMOUNT",
        value: values.enableBookingDeposit ? `${values.bookingDepositAmount}` : '0',
        id: data.DEPOSIT_AMOUNT.id,
      }
    ]
      const response = await updateAdminSettings({'settings' : reqData});
      if (response) {
        setSubmitting(false);
      }
    }
  });  
  
  useEffect(() => {
    if (data) {
      formik.setValues({
        enableBookingDeposit: data?.DEPOSIT?.value === 'ENABLED',
        bookingDepositAmount: data?.DEPOSIT_AMOUNT?.value || ''
      });
    }
},[data])

  // Add scroll to error effect
  useEffect(() => {
  if (Object.keys(formik.errors).length > 0 && formik.isSubmitting) {
      const firstErrorKey = Object.keys(formik.errors)[0];
      const element = document.getElementById(firstErrorKey);
      if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      element.focus();
      }
  }
  }, [formik.errors, formik.isSubmitting]);
      
  return (
    <Card>
        <CardBody>
        <CardTitle tag="h4" className='mb-4'>Deposit Settings</CardTitle>
        <Form onSubmit={formik.handleSubmit} autoComplete="off">            
            <div className="mb-4">
                <div className="mb-3">
                  <div className="form-check">
                    <Input
                      type="checkbox"
                      className="form-check-input"
                      id="enableBookingDeposit"
                      name="enableBookingDeposit"
                      checked={formik.values.enableBookingDeposit}
                      onChange={formik.handleChange}
                      disabled={data?.DEPOSIT?.can_update !== 1}
                    />
                    <Label className="form-check-label" htmlFor="enableBookingDeposit">
                      Enable Deposit
                    </Label>
                  </div>
                </div>

            {formik.values.enableBookingDeposit && (
                <Row>
                <Col sm="6">
                    <div className="mb-3">                    
                    <Label htmlFor="bookingDepositAmount">Deposit Amount <span className="text-danger">*</span></Label>
                    <Input
                        id="bookingDepositAmount"
                        name="bookingDepositAmount"
                        type="number"
                        // step="0.01"
                        placeholder="Enter deposit amount"
                        value={formik.values.bookingDepositAmount}
                        onChange={formik.handleChange}
                        invalid={formik.touched.bookingDepositAmount && formik.errors.bookingDepositAmount ? true : false}
                        disabled={data?.DEPOSIT_AMOUNT?.can_update !== 1}
                    />                    
                    {formik.errors.bookingDepositAmount && formik.touched.bookingDepositAmount && (
                        <FormFeedback type="invalid">{String(formik.errors.bookingDepositAmount)}</FormFeedback>
                    )}
                    </div>
                </Col>
                </Row>
            )}
            </div>

            <div className="d-flex flex-wrap gap-2 justify-content-end">
            <Button type="submit" color="primary" disabled={formik.isSubmitting}>
                {formik.isSubmitting ? 'Saving...' : 'Save Charges'}
            </Button>
            </div>
        </Form>
        </CardBody>
    </Card>
  )
}

export default Deposits
